import { type Common } from './common.js';
import { type PatientAdvisory } from './models/patientAdvisory.js';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async findAllByEncounterId(encounterId: string): Promise<PatientAdvisory[]> {
    const url = this.common.constructPath(`/patient-advisories`, {
      encounterId,
    });

    return await this.common.getJSON(url);
  }
}
